import { useMemo } from 'react';
import { Grid } from '@/uicomponents';

const { useBreakpoint } = Grid;

export function useScreenBreakpoint() {
  const screens = useBreakpoint();

  const currentScreenSize = useMemo(() => {
    const sizes = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'] as const;
    for (const size of sizes) {
      if (screens[size]) {
        return size;
      }
    }
    return '';
  }, [screens]);

  return {
    ...screens,
    currentScreenSize,
  };
}
